import React from 'react';

import {isSameDay, startOfDay} from 'date-fns';

import Button from '@pb/kit-component-button';
import {Icon, Icons} from '@pb/kit-component-icon';

export interface DefaultTodayButtonProps {
    selected?: Date | null,
    maxDate?: Date,
    minDate?: Date,
}

const isTodayDisabled = (
    selected: Date | null | undefined,
    maxDate: Date | undefined,
    minDate: Date | undefined,
): boolean => {
    const today = new Date();

    // Check if today is already selected
    if (selected && isSameDay(today, selected)) {
        return true;
    }

    // Check if today is after maxDate
    if (maxDate && startOfDay(today) > startOfDay(maxDate)) {
        return true;
    }

    // Check if today is before minDate
    if (minDate && startOfDay(today) < startOfDay(minDate)) {
        return true;
    }

    return false;
};

export const defaultTodayButton = ({selected, maxDate, minDate}: DefaultTodayButtonProps) => {
    const isDisabled = isTodayDisabled(selected, maxDate, minDate);

    return (
        <Button
            variant="Type.SECONDARY"
            size="small"
            style={{width: '100%'}}
            disabled={isDisabled}>
            <Icon type={Icons.CALENDAR}/>

            <span className="pl-s">
                Today
            </span>
        </Button>
    );
};
